import {

    Dimensions,

} from 'react-native';

export const support = {
'mail':'support@urlaubsgruss.com',
'appname':'Adventskalender',
'device':'WebApp',
'version':'v. 2025.1.1',
}

export const passwort = 'ug0411';

//export const kartenVerlaufLinear = {'mode':'linear','start':'#cbb74d','end':'#ffffff','x1':'0%','y1':'0%','x2':'100%','y2':'100%'};
export const kartenVerlaufLinear = {'mode':'linear','start':'#7e8c99','end':'#b4bcc3','x1':'0%','y1':'0%','x2':'100%','y2':'100%'};
//export const kartenVerlaufRadial = {'mode':'radial','start':'#ffffff','end':'#cbb74d','x1':'0%','y1':'0%','x2':'100%','y2':'0%'};
export const kartenVerlaufRadial = {'mode':'radial','start':'#b4bcc3','end':'#7e8c99','x1':'0%','y1':'0%','x2':'100%','y2':'0%'};
export const hintergrundVerlauf = {'mode':'linear','start':'#4cbcd6','end':'#ffffff','x1':'0%','y1':'0%','x2':'0%','y2':'100%'};

export function mLocale () {
        var loc = 'de';
        var locale = 'en';
        if ( loc.startsWith("de") ){
            locale = 'de';
        }
        if ( loc.startsWith("fr") ){
            locale = 'fr';
        }
    return locale;
};
export const Doors = {
'doorBorderWidth':2,
'doorNumberColor':'#ffffff',
'doorBorderColor':'#ffffff',
};

//'primary':'#339966',
export const MainColor = {
'primary':'#009ee0',
'signal':'#bb0c0c',
'graydark':'#808080',
'darkgray':'#808080',
'graylight':'#bdbdbd',
'grayultralight':'#e0e0e0',
'plholder':'#9e9e9e',
'card':'#fafafa',
'switchtint':'#ffffff',
'background':'#ffffff',
'green':'#339966',
'gelb':'#ffeb3b',
'postgelb':'#fdc90c',
'welcome':'#009ee075',
'iconprimary':'#ffffff',
'btnprimary':'#009ee0',
'dark':'#444444',
'primarylight':'#009ee033',
'signallight':'#ff418133',
'signallight2':'#ffbad1',
'goldlight':'#cbb74d33',
'greenlight':'#8bc34a33',
'shadow':'#80808050',
'schatten':'#808080',
'gold':'#cbb74d',
'blaugrau':'#7e8c99',
'blaugraulight':'#b4bcc3',
'blaugraulightmitalpha':'#b4bcc399',
'dunkelblaugrau':'#525c60',
'headline':'#396886',
'borderColor':'#009ee0',
'frames':'#396886',
'tabheader':'#396886',
'text':'#4e4e50',
'texteditback':'#eaeaea',
'startmuster':'#ffffff',
'starthintergrund':'#262626',
'startanimation':'#8bc34a',
};
//'iconprimary':'#808080',
//'btnprimary':'#f9f9f9',

export const Headerstyle =
{ backgroundColor: MainColor.primary, width: '100%', height:Dimensions.get('window').height>Dimensions.get('window').width?50:50, marginTop:0, paddingTop:Dimensions.get('window').height>Dimensions.get('window').width?0:0 };
export const Headerheight = Dimensions.get('window').height>Dimensions.get('window').width?50:50;
export const HeaderAndFooterheight = 100;


export const urls = {
'getEmail':'/adventskalender/geafak.php',
'sendEmail':'/adventskalender/sgcm.php',
'getGewinn':'/adventskalender/ggcfak.php',
'facebook':'https://facebook.com/urlaubsgruss',
'instagram':'https://www.instagram.com/urlaubsgruss',
'youtube':'https://www.youtube.com/urlaubsgrusscom',
'twitter':'https://twitter.com/Urlaubsgruss',
'pinterest':'https://pinterest.com/urlaubsgruss/',
'gooleApp':'https://play.google.com/store/apps/details?id=de.Postkarte',
'appleApp':'https://itunes.apple.com/de/app/id533470794',
'impressum':'https://www.urlaubsgruss.com/adventskalender/spielregeln/impressum.html',
'agb':'https://www.urlaubsgruss.com/mobileapps2/legalfiles/de/agb.html',
'datenschutz':'https://www.urlaubsgruss.com/adventskalender/spielregeln/datenschutz.html',
'urlaubsgruss':'https://www.urlaubsgruss.com/postkartenapp',
'urlaubsgrussMotive':'https://www.urlaubsgruss.com/postkarten-motive-weihnachten.html',
'teilnahmebedingungen':'https://www.urlaubsgruss.com/adventskalender/spielregeln/spielregeln.html',
}

